module.exports = __webpack_public_path__ + "img/trash.f53f5595.svg";